module.exports = __webpack_public_path__ + "img/ipost.833cd971.png";